import { create } from 'zustand';

interface UIState {
  bottomBarOpen: boolean;
  sidebarMinimized: boolean;
  sidebarOpen: boolean;
  youtubeOn: boolean;
}

interface UIActions {
  setBottomBarOpen: (open: boolean) => void;
  setSidebarMinimized: (minimized: boolean) => void;
  setSidebarOpen: (open: boolean) => void;
  setYoutubeOn: (on: boolean) => void;
}

export const useUIStore = create<UIState & UIActions>((set) => ({
  // State
  bottomBarOpen: false,
  sidebarMinimized: true,
  sidebarOpen: false,
  youtubeOn: false,

  // Actions
  setBottomBarOpen: (open) => set({ bottomBarOpen: open }),
  setSidebarMinimized: (minimized) => set({ sidebarMinimized: minimized }),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  setYoutubeOn: (on) => set({ youtubeOn: on }),
}));
